var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"label"},[_vm._v("Planilha")]),_c('input',{attrs:{"state":Boolean(_vm.file),"type":"file","placeholder":"Importar planilha...","drop-placeholder":"Importar planilha..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }